export const PLUGIN_NAME = 'campaign';

// The single localStorage key the captured set lives under. Blaze's own cart id
// sits alongside it in localStorage, so both are shared across tabs.
export const STORAGE_KEY = 'blaze_kelsey_landing';

// Named campaign parameters. `offer` also drives variant matching (KEL-263);
// `source` and `channel` feed the Darwin alt campaign code later on.
export const CAMPAIGN_PARAMS = ['offer', 'source', 'channel'];

// Every `utm_*` parameter is captured as well, for order level attribution that
// does not depend on GA.
export const UTM_PREFIX = 'utm_';

// Values come straight from the url, so both the size of each value and the
// number of utm keys are capped before anything is held or stored.
export const MAX_VALUE_LENGTH = 100;
export const MAX_UTM_PARAMS = 10;

export const ATTRIBUTION = {
  // An earlier, unexpired capture is kept when a later campaign url arrives.
  FIRST: 'first',
  // A later campaign url replaces the earlier capture.
  LAST: 'last'
};

export const CONSENT_MODES = {
  // Store without checking. The placeholder until Kelsey confirms the basis.
  ASSUMED: 'assumed',
  // Store only once Didomi reports the configured purposes and vendors enabled.
  DIDOMI: 'didomi',
  // Store only when a site supplied `hasConsent` function says so.
  CUSTOM: 'custom',
  // Never store; values are held in memory for the current page only.
  DISABLED: 'disabled'
};

// The namespace the captured set is sent under in the checkout additionalDetails.
// api-shopware reads the same key.
export const CHECKOUT_DETAILS_KEY = 'campaign';

// Emitted by the ecommerce CheckoutButton once the order exists (the event GTM
// reports the purchase from), after which the captured set has done its job.
export const PURCHASE_EVENT = 'plugin:ecommerce:event:purchase';

export const DEFAULT_EXPIRY_DAYS = 30;
export const DEFAULT_ATTRIBUTION = ATTRIBUTION.FIRST;
export const DEFAULT_CONSENT = { mode: CONSENT_MODES.ASSUMED };

export const DAY_IN_MS = 24 * 60 * 60 * 1000;

// setTimeout's limit; a longer delay would fire immediately.
export const MAX_TIMEOUT_MS = 2 ** 31 - 1;
